/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* GPT 5 MARZO 26 - per evitare aggiunta prodotti accidentale con tasto "INVIO" quando si è in pagina prodotto" - 
Monitorare:
- che altre app che agiscono in product page non abbiano problemi (cookie, DPO, ecc )
- che su altri browser non si verifichi poroblema (invio e aggiunta prodotto al carrello senza aprire dpo) */
(function(){
  if (!document.body.classList.contains('template-product')) return;

  var enterTs = 0;
  var WINDOW_MS = 450; // più stretto = meno rischio blocchi involontari

  // 1) marca quando premi Enter
  document.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.keyCode === 13) enterTs = Date.now();
  }, true);

  // 2) blocca click “implicito” sul bottone ATC subito dopo Enter
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest
      ? e.target.closest('.product-form__add-button,[data-action="add-to-cart"]')
      : null;
    if (!btn) return;

    if (Date.now() - enterTs < WINDOW_MS) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // 3) safety net: blocca la chiamata Ajax a /cart/add* subito dopo Enter
  var _fetch = window.fetch;
  window.fetch = function(input, init){
    try{
      var url = (typeof input === 'string')
        ? input
        : (input && input.url) ? input.url : '';

      var base = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';
      var dt = Date.now() - enterTs;

      // matcha anche URL assolute e con query
      var isAdd =
        url && (
          url.indexOf(base + '.js') !== -1 ||
          url.indexOf(base + '.json') !== -1 ||
          url.indexOf(base) !== -1
        );

      if (isAdd && dt < WINDOW_MS) {
        return Promise.resolve(new Response("{}", {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
    } catch(_) {}

    return _fetch.apply(this, arguments);
  };
})();

/* FINE BLOCCO GPT 5 MARZO 26 - per evitare aggiunta prodotti accidentale con tasto "INVIO" quando si è in pagina prodotto" - 
se da problemi lo tolgo */

$(document).ready(function() {
  // mostra di più (usato per la descrizione delle collection)
  $(".toggle_btn").click(function() {
    $(this).toggleClass("active");
    $(".wrapper-accordion .accordion-item").toggleClass("active");
    if($(".toggle_btn").hasClass("active")) {
      $(".toggle_text").text("Mostra meno");
    } else {
      $(".toggle_text").text("Mostra più");
    }
  });

  // Per le FAQ
  // Configuro con le seguenti variabili
  var showChar = 390;  // Imposta il numero di caratteri da visualizzare prima di far apparire il "read more"
  var ellipsestext = "...";
  var moretext = "Mostra più";
  var lesstext = "Mostra meno";
  
  $('.more').each(function() {
      var content = $(this).html();
      if(content.length > showChar) {
          var c = content.substr(0, showChar);
          var h = content.substr(showChar, content.length - showChar);
          var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
          $(this).html(html);
      }
  });

  $(".morelink").click(function(){
      if($(this).hasClass("less")) {
          $(this).removeClass("less");
          $(this).html(moretext);
      } else {
          $(this).addClass("less");
          $(this).html(lesstext);
      }
      $(this).parent().prev().toggle();
      $(this).prev().toggle();
      return false;
  });
  
});

